const appendScriptFromPlatformEndpoint = (fsPlatformInfo) => {
    const fsPlatformConfig = fsPlatformInfo.config;
    const fsPlatformUIEndpoint = `${fsPlatformConfig.uiResourceHost}${fsPlatformConfig.prefix}`;
    const updateElementScript = document.createElement("script");
    updateElementScript.src = `${fsPlatformUIEndpoint}/js/updateElement.js`;
    const parentElementScript = document.createElement("script");
    parentElementScript.src = `${fsPlatformUIEndpoint}/js/parent.js`;
    const fullStoryElementScript = document.createElement("script");
    fullStoryElementScript.src = `${fsPlatformUIEndpoint}/js/fullStory.js`;
    document.body.appendChild(updateElementScript);
    document.body.appendChild(parentElementScript);
    document.body.appendChild(fullStoryElementScript);
};

export default { appendScriptFromPlatformEndpoint };